// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2VxIJ","productName":"Table_productName__TYAO_"};